const ACCESS_CODE_REDIRECT = 'ACCESS_CODE_REDIRECT';
const ACCOUNT_ACCESS_CODE = 'ACCOUNT_ACCESS_CODE';
const ACCOUNT_LOGIN = 'ACCOUNT_LOGIN';
const ACCOUNT_SIGNUP = 'ACCOUNT_SIGNUP';
const ACK_TRNFR_STATUS = 'ACK_TRNFR_STATUS';
const ADDITIONAL_INFO = 'ADDITIONAL_INFO';
const ADD_CONSUMER = 'ADD_CONSUMER';
const ADD_CONSUMER_WITHOUT_CALL_ID = 'ADD_CONSUMER_WITHOUT_CALL_ID';
const ADD_MEMBER = 'ADD_MEMBER';

const RIDP_CURRENT_USER_INFO_ENDPOINT = 'RIDP_CURRENT_USER_INFO_ENDPOINT';
const RIDP_VIEWREF_ENDPOINT = 'RIDP_VIEWREF_ENDPOINT';
const RIDP_VALIDATE_PRIMARY_ENDPOINT = 'RIDP_VALIDATE_PRIMARY_ENDPOINT';
const RIDP_VALIDATE_SECONDARY_ENDPOINT = 'RIDP_VALIDATE_SECONDARY_ENDPOINT';
const RIDP_MANUAL_VERIFICATION_ENDPOINT = 'RIDP_MANUAL_VERIFICATION_ENDPOINT';
const RIDP_VALIDATE_FARS_ENDPOINT = 'RIDP_VALIDATE_FARS_ENDPOINT';
const RIDP_CLEAR_DHS_ENDPOINT = 'RIDP_CLEAR_DHS_ENDPOINT';
const TOBACCO_EXEMPT_GET_APPLICANTS = 'TOBACCO_EXEMPT_GET_APPLICANTS';
const TOBACCO_EXEMPT_SAVE_ADDINFO = 'TOBACCO_EXEMPT_SAVE_ADDINFO';
const DMI_GET_DMI_VERIFICATIONS = 'DMI_GET_DMI_VERIFICATIONS';
const DMI_VLP_VERIFICATIONS = 'DMI_VLP_VERIFICATIONS';
const AGENT_LEFT_NAV_PARAMS = 'AGENT_LEFT_NAV_PARAMS';
const AGENT_LIST = 'AGENT_LIST';
const AGENTS_SEARCH_BY_NAME = 'AGENTS_SEARCH_BY_NAME';
const AGENTS_SEARCH_BY_ZIP = 'AGENTS_SEARCH_BY_ZIP';
const ANNOUNCEMENTS = 'ANNOUNCEMENTS';
const APPLICATIONS = 'APPLICATIONS';
const APPLICATIONS_NEW = 'APPLICATIONS_NEW';
const ARCHIVE_HH_ARCHIVE = 'ARCHIVE_HH_ARCHIVE';
const ARCHIVE_HH_SEARCH = 'ARCHIVE_HH_SEARCH';
const ARCHIVE_HH_UNARCHIVE = 'ARCHIVE_HH_UNARCHIVE';
const SSIO_EXECUTE_STEP = 'SSIO_EXECUTE_STEP';
const SSIO_TEST_PLAN_RESULTS = 'SSIO_TEST_PLAN_RESULTS';
const SSIO_TEST_PLAN_DETAILS = 'SSIO_TEST_PLAN_DETAILS';
const SSIO_RESTART_STEP = 'SSIO_RESTART_STEP';
const ASSISTER_VIEW_PROFILE = 'ASSISTER_VIEW_PROFILE';
const ASSISTER_IND = 'ASSISTER_IND';
const AUTHENTICATION_SUCCESS_REDIRECT = 'AUTHENTICATION_SUCCESS_REDIRECT';
const BACK_TO_DASHBOARD = 'BACK_TO_DASHBOARD';
const BLOOD_RELATIONSHIPS_CHECK = 'BLOOD_RELATIONSHIPS_CHECK';
const BLOOD_RELATIONSHIPS_ENDPOINT = 'BLOOD_RELATIONSHIPS_ENDPOINT';
const BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST = 'BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST';
const BROKER_ADD_NEW_INDIVIDUAL = 'BROKER_ADD_NEW_INDIVIDUAL';
const BROKER_EMP = 'BROKER_EMP';
const BROKER_IND = 'BROKER_IND';
const BROKER_NEW_EMP = 'BROKER_NEW_EMP';
const BROKER_TICKET = 'BROKER_TICKET';
const BROKER_VIEW_PENDING_INDIVIDUAL = 'BROKER_VIEW_PENDING_INDIVIDUAL';
const BROKER_VIEW_PROFILE = 'BROKER_VIEW_PROFILE';
const BROKERCONNECT_DATA = 'BROKERCONNECT_DATA';
const BROKERCONNECT_PARTICIPATION_DETAILS = 'BROKERCONNECT_PARTICIPATION_DETAILS';
const BROKERCONNECT_NAVBARS = 'BROKERCONNECT_NAVBARS';
const BROKERCONNECT_HOURS = 'BROKERCONNECT_HOURS';
const BROKERCONNECT_AVAILABILITY = 'BROKERCONNECT_AVAILABILITY';
const CANCEL_APP = 'CANCEL_APP';
const CEC_EXPORT_BOB = 'CEC_EXPORT_BOB';
const CEC_EXPORT_BOB_NON_CA = 'CEC_EXPORT_BOB_NON_CA';
const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
const CHANGE_APP_STATUS = 'CHANGE_APP_STATUS';
const CHECK_ACTIVE_ENROLLMENT = 'CHECK_ACTIVE_ENROLLMENT';
const COPY_APP_BY_CASE_NUMBER = 'COPY_APP_BY_CASE_NUMBER';
const CLONE_APP_BY_CASE_NUMBER = 'CLONE_APP_BY_CASE_NUMBER';
const CLONE_APP_BY_SSAP_ID = 'CLONE_APP_BY_SSAP_ID';
const COMMENTS = 'COMMENTS';
const COMMUNICATION_PREFERENCES = 'COMMUNICATION_PREFERENCES';
const OTP_VERIFY = 'OTP_VERIFY';
const OTP_SEND = 'OTP_SEND';
const PARTIAL_UPDATE = 'PARTIAL_UPDATE';
const TELEX_ENVIRONMENT = 'TELEX_ENVIRONMENT';
const COUNTIES_FOR_STATE_ENDPOINT = 'COUNTIES_FOR_STATE_ENDPOINT';
const COUNTIES_FOR_STATES_ENDPOINT = 'COUNTIES_FOR_STATES_ENDPOINT';
const COUNTRIES_ENDPOINT = 'COUNTRIES_ENDPOINT';
const COUNTY_ENDPOINT = 'COUNTY_ENDPOINT';
const CUSTOM_GROUPING = 'CUSTOM_GROUPING';
const DASHBOARD_ENDPOINT = 'DASHBOARD_ENDPOINT';
const DASHBOARD_MODELS = 'DASHBOARD_MODELS';
const DASHBOARD_MODELS_LITE = 'DASHBOARD_MODELS_LITE';
const DELEGATION_HISTORY = 'DELEGATION_HISTORY';
const DISENROLL_MEMBERS = 'DISENROLL_MEMBERS';
const DOCUMENTS_VERIFICATION_DATA = 'DOCUMENTS_VERIFICATION_DATA';
const DOCUMENTS_VERIFICATION_ENDPOINT = 'DOCUMENTS_VERIFICATION_ENDPOINT';
const EDE_ID_PROOFING_ENDPOINT = 'EDE_ID_PROOFING_ENDPOINT';
const EDE_SEARCH_ENDPOINT = 'EDE_SEARCH_ENDPOINT';
const EDE_SEARCH_ADD_TO_BOB = 'EDE_SEARCH_ADD_TO_BOB';
const EDE_ADD_CONSUMER = 'EDE_ADD_CONSUMER';
const EDE_BACK_TO_DASHBOARD = 'EDE_BACK_TO_DASHBOARD';
const EDE_BACK_TO_ACTIVE_INDIVIDUALS = 'EDE_BACK_TO_ACTIVE_INDIVIDUALS';
const ELIGIBILITY_RESULTS = 'ELIGIBILITY_RESULTS';
const ELIGIBILITY_RESULTS_NEW = 'ELIGIBILITY_RESULTS_NEW';
const EMAIL_PDF_PREVIEW = 'EMAIL_PDF_PREVIEW';
const EMAIL_PDF_PREVIEW_WITH_IMPERSONATION = 'EMAIL_PDF_PREVIEW_WITH_IMPERSONATION';
const ENLARGED_FONT_ENABLED = 'ENLARGED_FONT_ENABLED';
const MEMBER_ENROLLMENT_LIST_DETAILS = 'MEMBER_ENROLLMENT_LIST_DETAILS';
const MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS = 'MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS';
const MEMBER_ENROLLMENT_DETAILS = 'MEMBER_ENROLLMENT_DETAILS';
const MEMBER_ENROLLMENT_LIST_PERMISSIONS = 'MEMBER_ENROLLMENT_LIST_PERMISSIONS';
const MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT = 'MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT';
const MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT = 'MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT';
const MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS = 'MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS';
const MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS = 'MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS';
const MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE = 'MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE';
const MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY =
    'MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY';
const MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT = 'MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT';
const ENTITY_ASSISTERS_LIST = 'ENTITY_ASSISTERS_LIST';
const ENTITY_SITE_LIST = 'ENTITY_SITE_LIST';
const ENVIRONMENT_VARIABLES = 'ENVIRONMENT_VARIABLES';
const EXTERNAL_CONTENT = 'EXTERNAL_CONTENT';
const FILTER_CEC_ENTITYADMIN = 'FILTER_CEC_ENTITYADMIN';
const FLOW_ENDPOINT = 'FLOW_ENDPOINT';
const GA_CARRIER_GAEP_LIST = 'GA_CARRIER_GAEP_LIST';
const GET_ENROLLMENT_HISTORY = 'GET_ENROLLMENT_HISTORY';
const GET_EXISTING_APP_ID = 'GET_EXISTING_APP_ID';
const GET_IVR_DATA = 'GET_IVR_DATA';
const GET_TRNFR_STATUS = 'GET_TRNFR_STATUS';
const GET_UNREAD_NOTIFICATION_COUNT = 'GET_UNREAD_NOTIFICATION_COUNT';
const GET_SSN_DETAILS = 'GET_SSN_DETAILS';
const HEADER_ROLES_LINK = 'HEADER_ROLES_LINK';
const HTML_2_PDF_SCRIPT_ENDPOINT = 'HTML_2_PDF_SCRIPT_ENDPOINT';
const IDA_LINK = 'IDA_LINK';
const IMAGES = 'IMAGES';
const INBOX_HOME = 'INBOX_HOME';
const INDPORTAL_ERROR = 'INDPORTAL_ERROR';
const INITIAL_DATA_ENDPOINT = 'INITIAL_DATA_ENDPOINT';
const ISSUER_LIST = 'ISSUER_LIST';
const IVM_DOWNLOAD_DOCUMENT = 'IVM_DOWNLOAD_DOCUMENT';
const IVM_CONFIRMATION = 'IVM_CONFIRMATION';
const IVM_ENVIRONMENT = 'IVM_ENVIRONMENT';
const IVM_ISSUER_LIST = 'IVM_ISSUER_LIST';
const IVM_PREVIEW_PACKET = 'IVM_PREVIEW_PACKET';
const IVM_PREVIEW_STATEMENT = 'IVM_PREVIEW_STATEMENT';
const IVM_RESEND_PACKETS = 'IVM_RESEND_PACKETS';
const IVM_REVIEW_PACKET = 'IVM_REVIEW_PACKET';
const IVM_SEND_PACKET = 'IVM_SEND_PACKET';
const IVM_STATEMENT_PACKETS = 'IVM_STATEMENT_PACKETS';
const IVM_UPDATE_EMAIL_PHONE = 'IVM_UPDATE_EMAIL_PHONE';
const IVM_UPDATE_COMMENTS = 'IVM_UPDATE_COMMENTS';
const J_SECURITY_CHECK = 'J_SECURITY_CHECK';
const LOGOUT_URL = 'LOGOUT_URL';
const LCE_REFERRAL = 'LCE_REFERRAL';
const LCE_CLONE = 'LCE_CLONE';
const LOG_CALL_DATA = 'LOG_CALL_DATA';
const MEMBER_AFFORDABILITY = 'MEMBER_AFFORDABILITY';
const MOCKS = 'MOCKS';
const MODAL_MOCKS = 'MODAL_MOCKS';
const MULTIHOUSEHOLD_DETAILS = 'MULTIHOUSEHOLD_DETAILS';
const NAV_BAR = 'NAV_BAR';
const NEW_INBOX_HOME = 'NEW_INBOX_HOME';
const NOTIFICATIONS = 'NOTIFICATIONS';
const OLD_START_SSAP_BY_CASE_NUMBER = 'OLD_START_SSAP_BY_CASE_NUMBER';
const OVERRIDE_DOCUMENTS = 'OVERRIDE_DOCUMENTS';
const PARTNER_BROKER = 'PARTNER_BROKER';
const PARTNER_LIST = 'PARTNER_LIST';
const PLAN_SHOPPING = 'PLAN_SHOPPING';
const PING = 'PING';
const PAY_FOR_HEALTH = 'PAY_FOR_HEALTH';
const CHANGE_TERMINATION_DATE = 'CHANGE_TERMINATION_DATE';
const POST_TICKET = 'POST_TICKET';
const PRE_ELIGIBILITY = 'PRE_ELIGIBILITY';
const PRE_ELIGIBILITY_BROWSE_PLANS = 'PRE_ELIGIBILITY_BROWSE_PLANS';
const PRE_ELIGIBILITY_BROWSE_PLANS_REDIRECT = 'PRE_ELIGIBILITY_BROWSE_PLANS_REDIRECT';
const PRE_ELIGIBILITY_CALCULATE_SAVINGS = 'PRE_ELIGIBILITY_CALCULATE_SAVINGS';
const PRE_ELIGIBILITY_DISCLAIMER_JSP = 'PRE_ELIGIBILITY_DISCLAIMER_JSP';
const PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME = 'PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME';
const PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW = 'PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW';
const PRE_ELIGIBILITY_DISCLAIMER = 'PRE_ELIGIBILITY_DISCLAIMER';
const PRE_ELIGIBILITY_RESULTS = 'PRE_ELIGIBILITY_RESULTS';
const PRE_ELIGIBILITY_RESULTS_APTC_IMAGE = 'PRE_ELIGIBILITY_RESULTS_APTC_IMAGE';
const PRE_ELIGIBILITY_RESULTS_CSR_IMAGE = 'PRE_ELIGIBILITY_RESULTS_CSR_IMAGE';
const PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE = 'PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE';
const PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE = 'PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE';
const PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE = 'PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE';
const PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE = 'PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE';
const PRE_ELIGIBILITY_RESULTS_NA_IMAGE = 'PRE_ELIGIBILITY_RESULTS_NA_IMAGE';
const PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE = 'PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE';
const PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE = 'PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE';
const PRE_ELIGIBILITY_RESULTS_NAVIGATE_NEXT = 'PRE_ELIGIBILITY_RESULTS_NAVIGATE_NEXT';
const PRE_ELIGIBILITY_SCREENING = 'PRE_ELIGIBILITY_SCREENING';
const PLAN_SUMMARY = 'PLAN_SUMMARY';
const QEP = 'QEP';
const REASSIGN_BOB_TO_CEC = 'REASSIGN_BOB_TO_CEC';
const REMOVE_UPLOADED_DOCUMENT = 'REMOVE_UPLOADED_DOCUMENT';
const REPORT_A_CHANGE = 'REPORT_A_CHANGE';
const REQUEST_FULL_DETERMINATION = 'REQUEST_FULL_DETERMINATION';
const REVIEW_SUMMARY_PDF_DOWNLOAD = 'REVIEW_SUMMARY_PDF_DOWNLOAD';
const SAVE_COMMENT = 'SAVE_COMMENT';
const SAVE_CUSTOM_GROUPING = 'SAVE_CUSTOM_GROUPING';
const SAVE_DATA_ENDPOINT = 'SAVE_DATA_ENDPOINT';
const SAVE_TOBACCO = 'SAVE_TOBACCO';
const SAVE_SEEKS_QHP_CHANGES = 'SAVE_SEEKS_QHP_CHANGES';
const SSAP_PRE_ELIGIBILITY = 'SSAP_PRE_ELIGIBILITY';
const SEARCH_APPLICANT = 'SEARCH_APPLICANT';
const SEARCH_CEC = 'SEARCH_CEC';
const SECURE_INBOX_SEND = 'SECURE_INBOX_SEND';
const SCREENPOP_ASSISTER_DATA = 'SCREENPOP_ASSISTER_DATA';    
const SCREENPOP_BROKER_DATA = 'SCREENPOP_BROKER_DATA';
const SET_ACTIVE_HOUSEHOLD = 'SET_ACTIVE_HOUSEHOLD';
const SET_FULL_DETERMINATION = 'SET_FULL_DETERMINATION';
const START_SHOPPING = 'START_SHOPPING';
const START_SSAP_BY_CASE_NUMBER = 'START_SSAP_BY_CASE_NUMBER';
const START_SSAP_BY_YEAR = 'START_SSAP_BY_YEAR';
const SUBMIT_DOCUMENTS = 'SUBMIT_DOCUMENTS';
const TERMINATE_DENTAL_PLAN = 'TERMINATE_DENTAL_PLAN';
const TERMINATE_HEALTH_PLAN = 'TERMINATE_HEALTH_PLAN';
const TERMINATE_PLAN = 'TERMINATE_PLAN';
const TICKET_DETAIL = 'TICKET_DETAIL';
const TICKET_TYPES = 'TICKET_TYPES';
const TICKET_MGMT_CREATE_PAGE = 'TICKET_MGMT_CREATE_PAGE';
const TICKET_MGMT_LIST = 'TICKET_MGMT_LIST';
const TICKET_MGMT_DEFAULT_QUEUE = 'TICKET_MGMT_DEFAULT_QUEUE';
const TICKET_MGMT_MANAGE_QUEUE = 'TICKET_MGMT_MANAGE_QUEUE';
const TICKET_MGMT_CATEGORIES = 'TICKET_MGMT_CATEGORIES';
const TICKET_MGMT_WORKFLOW_TYPES = 'TICKET_MGMT_WORKFLOW_TYPES';
const TICKET_MGMT_WORKGROUPS = 'TICKET_MGMT_WORKGROUPS';
const TICKET_MGMT_PERMISSIONS = 'TICKET_MGMT_PERMISSIONS';
const TICKET_MGMT_WORKFLOW_BY_CATEGORY = 'TICKET_MGMT_WORKFLOW_BY_CATEGORY';
const TICKET_MGMT_UPDATE_CATEGORY = 'TICKET_MGMT_UPDATE_CATEGORY';
const TICKET_MGMT_SAVE_NEW_TICKET_TYPE = 'TICKET_MGMT_SAVE_NEW_TICKET_TYPE';
const TICKET_MGMT_GET_CONSUMER_DATA = 'TICKET_MGMT_GET_CONSUMER_DATA';
const TICKET_MGMT_GET_TAGS = 'TICKET_MGMT_GET_TAGS';
const TICKET_MGMT_UPDATE_TAG = 'TICKET_MGMT_UPDATE_TAG';
const TICKET_MGMT_WORKGROUPS_TAGS = 'TICKET_MGMT_WORKGROUPS_TAGS';
const TICKET_MGMT_WORKGROUPS_TAGS_BY_ID = 'TICKET_MGMT_WORKGROUPS_TAGS_BY_ID';
const TICKET_MGMT_TAGS_AUTOCOMPLETE_SEARCH = 'TICKET_MGMT_TAGS_AUTOCOMPLETE_SEARCH';
const TICKET_MGMT_WORKGROUP_TAGS_SAVE = 'TICKET_MGMT_WORKGROUP_TAGS_SAVE';
const TICKET_MGMT_WORKGROUPS_NAME_VALIDATION = 'TICKET_MGMT_WORKGROUPS_NAME_VALIDATION';
const TICKET_MGMT_UPDATE_WORKGROUP = 'TICKET_MGMT_UPDATE_WORKGROUP';
const TICKET_MGMT_EXCHANGE_ASSIGNEES = 'TICKET_MGMT_EXCHANGE_ASSIGNEES';
const TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES = 'TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES';
const TICKET_MGMT_TICKET_DETAIL = 'TICKET_MGMT_TICKET_DETAIL';
const TICKET_MGMT_TICKET_DETAIL_BACKDOOR = 'TICKET_MGMT_TICKET_DETAIL_BACKDOOR';
const TICKET_MGMT_TICKET_HISTORY = 'TICKET_MGMT_TICKET_HISTORY';
const TICKET_MGMT_TICKET_COMMENTS = 'TICKET_MGMT_TICKET_COMMENTS';
const TICKET_MGMT_TICKET_DOCUMENTS = 'TICKET_MGMT_TICKET_DOCUMENTS';
const TICKET_MGMT_TICKET_TASKLIST = 'TICKET_MGMT_TICKET_TASKLIST';
const TICKET_MGMT_TICKET_SEND_MESSAGE = 'TICKET_MGMT_TICKET_SEND_MESSAGE';
const TICKET_MGMT_REASSIGN_TICKET = 'TICKET_MGMT_REASSIGN_TICKET';
const TICKET_MGMT_GET_ACTIVE_TASKS = 'TICKET_MGMT_GET_ACTIVE_TASKS';
const TICKET_MGMT_GET_ALL_USERS_FOR_QUEUE = 'TICKET_MGMT_GET_ALL_USERS_FOR_QUEUE';
const TICKET_MGMT_GET_FILE_UPLOAD_FLAG = 'TICKET_MGMT_GET_FILE_UPLOAD_FLAG';
const TICKET_MGMT_GET_RECLASSIFIED_PROPERTIES = 'TICKET_MGMT_GET_RECLASSIFIED_PROPERTIES';
const TICKET_MGMT_GET_TICKET_TYPES = 'TICKET_MGMT_GET_TICKET_TYPES';
const TICKET_MGMT_SUBMIT_RECLASSIFY = 'TICKET_MGMT_SUBMIT_RECLASSIFY';
const TICKET_MGMT_CANCEL_TICKET = 'TICKET_MGMT_CANCEL_TICKET';
const TICKET_MGMT_REOPEN_TICKET = 'TICKET_MGMT_REOPEN_TICKET';
const TICKET_MGMT_USER_TASKLIST = 'TICKET_MGMT_USER_TASKLIST';
const TICKET_MGMT_COMPLETE_TASK = 'TICKET_MGMT_COMPLETE_TASK';
const TICKET_MGMT_UPLOAD_ATTACHMENTS = 'TICKET_MGMT_UPLOAD_ATTACHMENTS';
const TICKET_MGMT_SAVE_COMMENT = 'TICKET_MGMT_SAVE_COMMENT';
const TICKET_MGMT_WORKGROUPS_SEARCH_ALL = 'TICKET_MGMT_WORKGROUPS_SEARCH_ALL';
const TOBACCO_EXEMPT = 'TOBACCO_EXEMPT';
const GET_CUSTOM_FIELDS_URL = 'GET_CUSTOM_FIELDS_URL';
const GET_CUSTOM_FIELDS_FOR_DEV_ENVIRONMENT = 'GET_CUSTOM_FIELDS_FOR_DEV_ENVIRONMENT';
const GET_USER_SECURITY_DETAILS = 'GET_USER_SECURITY_DETAILS';
const RESET_PASSWORD = 'RESET_PASSWORD';
const RESET_PASSWORD_ALTERNATE_EMAIL = 'RESET_PASSWORD_ALTERNATE_EMAIL';
const UNLOCK_USER = 'UNLOCK_USER';
const TICKETS = 'TICKETS';
const VIEW_MEMBER_ACCOUNT = 'VIEW_MEMBER_ACCOUNT';
const TRIBES_ENDPOINT = 'TRIBES_ENDPOINT';
const UNREAD_MESSAGE_COUNT = 'UNREAD_MESSAGE_COUNT';
const UPLOAD_VERIFICATION_DOCUMENT = 'UPLOAD_VERIFICATION_DOCUMENT';
const VALIDATE_ZIP = 'VALIDATE_ZIP';
const VERIFICATION_PENDING = 'VERIFICATION_PENDING';
const VERIFICATION_RESULT_DASHBOARD = 'VERIFICATION_RESULT_DASHBOARD';
const VALIDATE_ADDRESS_ENDPOINT = 'VALIDATE_ADDRESS_ENDPOINT';
const VERIFY_ACCESS_CODE = 'VERIFY_ACCESS_CODE';
const VIEW_MEMBER = 'VIEW_MEMBER';
const WRONG_ENDPOINT = 'WRONG_ENDPOINT';
const ZIPCODE_COUNTIES = 'ZIPCODE_COUNTIES';
const FETCH_HOUSHOLDS_ELIGIBILITY = 'FETCH_HOUSHOLDS_ELIGIBILITY';
const PRE_OEP_LANDING = 'PRE_OEP_LANDING';
const WORKGROUP_BY_STATUS = 'WORKGROUP_BY_STATUS';
const WORKGROUP_BY_DUEDATE = 'WORKGROUP_BY_DUEDATE';
const WORKGROUP_BY_USER = 'WORKGROUP_BY_USER';
const WORKGROUP_DUEDATE_REPORT_BY_USER = 'WORKGROUP_DUEDATE_REPORT_BY_USER';
const GET_ATTACHMENTS_URL = 'GET_ATTACHMENTS_URL';
const POST_ATTACHMENTS_URL = 'POST_ATTACHMENTS_URL';
const DELETE_ATTACHMENT_URL = 'DELETE_ATTACHMENT_URL';
const UPLOADED_DOCUMENT_URL = 'UPLOADED_DOCUMENT_URL';
const VIEW_ATTACHMENT_URL = 'VIEW_ATTACHMENT_URL';
const RESOLVED_DATE_REPORTS_BY_WORKGROUP = 'RESOLVED_DATE_REPORTS_BY_WORKGROUP';
const RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE = 'RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE';
const RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN = 'RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN';
const RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN =
    'RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN';
const DMI_GET_HOUSEHOLD_INCOME = 'DMI_GET_HOUSEHOLD_INCOME';
const DMI_UPLOAD_DOCUMENT_ENDPOINT = 'DMI_UPLOAD_DOCUMENT_ENDPOINT';
const DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT = 'DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT';
const CHECK_FOR_PENDING_APPLICATION = 'CHECK_FOR_PENDING_APPLICATION';
const CUSTOM_GROUPING_DETAIL = 'CUSTOM_GROUPING_DETAIL';
const MEMBER_APP_LIST_CONTROLLER = 'MEMBER_APP_LIST_CONTROLLER';
const MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS = 'MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS';
const MEMBER_APP_LIST_GET_APPS = 'MEMBER_APP_LIST_GET_APPS';
const MEMBER_APP_LIST_OVERRIDE_COMMENT = 'MEMBER_APP_LIST_OVERRIDE_COMMENT';
const MEMBER_APP_LIST_INIT_VERIFICATIONS = 'MEMBER_APP_LIST_INIT_VERIFICATIONS';
const MEMBER_APP_LIST_RERUN_ELIGIBILITY = 'MEMBER_APP_LIST_RERUN_ELIGIBILITY';
const MEMBER_APP_LIST_TERMINATE_PLAN = 'MEMBER_APP_LIST_TERMINATE_PLAN';
const MEMBER_APP_LIST_REVERSE_DENIAL = 'MEMBER_APP_LIST_REVERSE_DENIAL';
const MEMBER_APP_LIST_UPDATE_CARRIER = 'MEMBER_APP_LIST_UPDATE_CARRIER';
const MEMBER_APP_LIST_SAVE_SEP_DETAILS = 'MEMBER_APP_LIST_SAVE_SEP_DETAILS';
const MEMBER_APP_LIST_SEND_OBAT = 'MEMBER_APP_LIST_SEND_OBAT';
const MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS = 'MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS';
const MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP = 'MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP';
const MEMBER_APP_LIST_CHECK_ACTIVE = 'MEMBER_APP_LIST_CHECK_ACTIVE';
const MEMBER_APP_LIST_PROGRAM_ELIGIBILITY = 'MEMBER_APP_LIST_PROGRAM_ELIGIBILITY';
const MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY = 'MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY';
const MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT = 'MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT';
const MEMBER_APP_LIST_SEP_EVENT_DETAILS = 'MEMBER_APP_LIST_SEP_EVENT_DETAILS';
const MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER = 'MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER';
const MEMBER_APP_LIST_GET_SEP_DETAILS = 'MEMBER_APP_LIST_GET_SEP_DETAILS';
const MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS = 'MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS';
const MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK = 'MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK';
const MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS = 'MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS';
const MEMBER_APP_LIST_GET_SEP_PERIOD_DATES = 'MEMBER_APP_LIST_GET_SEP_PERIOD_DATES';
const MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE = 'MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE';
const MEMBER_APP_LIST_GET_QHP_APPLICANTS = 'MEMBER_APP_LIST_GET_QHP_APPLICANTS';
const MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW = 'MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW';
const MEMBER_APP_LIST_NEW_SSAP_START = 'MEMBER_APP_LIST_NEW_SSAP_START';
const MEMBER_APP_LIST_APPLICATIONS = 'MEMBER_APP_LIST_APPLICATIONS';
const MEMBER_ACCOUNT_ACTIVITY_DETAILS = 'MEMBER_ACCOUNT_ACTIVITY_DETAILS';
const MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS = 'MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS';
const MEMBER_ACCOUNT_ACTIVITY_LOG_CALL = 'MEMBER_ACCOUNT_ACTIVITY_LOG_CALL';
const MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE = 'MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE';
const MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE = 'MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE';
const MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY = 'MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY';
const MEMBER_ACCOUNT_ACTIVITY_INIT_CALL = 'MEMBER_ACCOUNT_ACTIVITY_INIT_CALL';
const DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT = 'DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT';
const DMI_LOAD_DOCUMENT_ENDPOINT = 'DMI_LOAD_DOCUMENT_ENDPOINT';
const DMI_VIEW_UPLOADED_DOCUMENT_ENDPOINT = 'DMI_VIEW_UPLOADED_DOCUMENT_ENDPOINT';
const DMI_VIEW_TICKET_ENDPOINT = 'DMI_VIEW_TICKET_ENDPOINT';
const DMI_OVERRIDE_DOCUMENTS = 'DMI_OVERRIDE_DOCUMENTS';
const ADMIN_PROVISION_PRIVILEGES = 'ADMIN_PROVISION_PRIVILEGES';
const ADMIN_PROVISION_UPDATE_PRIVILEGES = 'ADMIN_PROVISION_UPDATE_PRIVILEGES';
const ADMIN_GET_DRUG_LIST = 'ADMIN_GET_DRUG_LIST';

export const ENDPOINTS_NAMES = {
    ACCESS_CODE_REDIRECT,
    ACCOUNT_ACCESS_CODE,
    ACCOUNT_LOGIN,
    ACCOUNT_SIGNUP,
    ACK_TRNFR_STATUS,
    ADDITIONAL_INFO,
    ADD_CONSUMER,
    ADD_CONSUMER_WITHOUT_CALL_ID,
    ADD_MEMBER,
    AGENTS_SEARCH_BY_NAME,
    AGENTS_SEARCH_BY_ZIP,
    AGENT_LEFT_NAV_PARAMS,
    AGENT_LIST,
    ANNOUNCEMENTS,
    APPLICATIONS,
    APPLICATIONS_NEW,
    ARCHIVE_HH_ARCHIVE,
    ARCHIVE_HH_SEARCH,
    ARCHIVE_HH_UNARCHIVE,
    ASSISTER_IND,
    ASSISTER_VIEW_PROFILE,
    AUTHENTICATION_SUCCESS_REDIRECT,
    BACK_TO_DASHBOARD,
    BLOOD_RELATIONSHIPS_CHECK,
    BLOOD_RELATIONSHIPS_ENDPOINT,
    BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST,
    BROKERCONNECT_DATA,
    BROKER_ADD_NEW_INDIVIDUAL,
    BROKER_EMP,
    BROKER_IND,
    BROKER_NEW_EMP,
    BROKER_TICKET,
    BROKER_VIEW_PENDING_INDIVIDUAL,
    BROKER_VIEW_PROFILE,
    BROKERCONNECT_PARTICIPATION_DETAILS,
    BROKERCONNECT_NAVBARS,
    BROKERCONNECT_HOURS,
    BROKERCONNECT_AVAILABILITY,
    CANCEL_APP,
    CEC_EXPORT_BOB,
    CEC_EXPORT_BOB_NON_CA,
    CHANGE_APP_STATUS,
    CHANGE_LANGUAGE,
    CHECK_ACTIVE_ENROLLMENT,
    CHECK_FOR_PENDING_APPLICATION,
    CLONE_APP_BY_CASE_NUMBER,
    CLONE_APP_BY_SSAP_ID,
    COMMENTS,
    COMMUNICATION_PREFERENCES,
    OTP_VERIFY,
    OTP_SEND,
    PARTIAL_UPDATE,
    TELEX_ENVIRONMENT,
    COPY_APP_BY_CASE_NUMBER,
    COUNTIES_FOR_STATES_ENDPOINT,
    COUNTIES_FOR_STATE_ENDPOINT,
    COUNTRIES_ENDPOINT,
    COUNTY_ENDPOINT,
    CUSTOM_GROUPING,
    CUSTOM_GROUPING_DETAIL,
    DASHBOARD_ENDPOINT,
    DASHBOARD_MODELS,
    DASHBOARD_MODELS_LITE,
    DELEGATION_HISTORY,
    DELETE_ATTACHMENT_URL,
    DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT,
    DMI_OVERRIDE_DOCUMENTS,
    DISENROLL_MEMBERS,
    DOCUMENTS_VERIFICATION_DATA,
    DOCUMENTS_VERIFICATION_ENDPOINT,
    DMI_UPLOAD_DOCUMENT_ENDPOINT,
    DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT,
    EDE_ADD_CONSUMER,
    EDE_BACK_TO_ACTIVE_INDIVIDUALS,
    EDE_BACK_TO_DASHBOARD,
    EDE_ID_PROOFING_ENDPOINT,
    EDE_SEARCH_ADD_TO_BOB,
    EDE_SEARCH_ENDPOINT,
    ELIGIBILITY_RESULTS,
    ELIGIBILITY_RESULTS_NEW,
    EMAIL_PDF_PREVIEW,
    EMAIL_PDF_PREVIEW_WITH_IMPERSONATION,
    ENLARGED_FONT_ENABLED,
    MEMBER_ENROLLMENT_LIST_DETAILS,
    MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS,
    MEMBER_ENROLLMENT_DETAILS,
    MEMBER_ENROLLMENT_LIST_PERMISSIONS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT,
    MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY,
    ENTITY_ASSISTERS_LIST,
    ENTITY_SITE_LIST,
    ENVIRONMENT_VARIABLES,
    EXTERNAL_CONTENT,
    FETCH_HOUSHOLDS_ELIGIBILITY,
    FILTER_CEC_ENTITYADMIN,
    FLOW_ENDPOINT,
    GET_ENROLLMENT_HISTORY,
    GA_CARRIER_GAEP_LIST,
    GET_ATTACHMENTS_URL,
    GET_CUSTOM_FIELDS_FOR_DEV_ENVIRONMENT,
    GET_CUSTOM_FIELDS_URL,
    GET_EXISTING_APP_ID,
    GET_IVR_DATA,
    GET_TRNFR_STATUS,
    GET_UNREAD_NOTIFICATION_COUNT,
    DMI_GET_DMI_VERIFICATIONS,
    DMI_VLP_VERIFICATIONS,
    DMI_GET_HOUSEHOLD_INCOME,
    GET_USER_SECURITY_DETAILS,
    GET_SSN_DETAILS,
    HEADER_ROLES_LINK,
    HTML_2_PDF_SCRIPT_ENDPOINT,
    IDA_LINK,
    IMAGES,
    INBOX_HOME,
    INDPORTAL_ERROR,
    INITIAL_DATA_ENDPOINT,
    ISSUER_LIST,
    IVM_CONFIRMATION,
    IVM_DOWNLOAD_DOCUMENT,
    IVM_ENVIRONMENT,
    IVM_ISSUER_LIST,
    IVM_PREVIEW_PACKET,
    IVM_PREVIEW_STATEMENT,
    IVM_RESEND_PACKETS,
    IVM_REVIEW_PACKET,
    IVM_SEND_PACKET,
    IVM_STATEMENT_PACKETS,
    IVM_UPDATE_COMMENTS,
    IVM_UPDATE_EMAIL_PHONE,
    J_SECURITY_CHECK,
    LCE_CLONE,
    LCE_REFERRAL,
    DMI_LOAD_DOCUMENT_ENDPOINT,
    LOGOUT_URL,
    LOG_CALL_DATA,
    MEMBER_ACCOUNT_ACTIVITY_DETAILS,
    MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS,
    MEMBER_ACCOUNT_ACTIVITY_LOG_CALL,
    MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE,
    MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE,
    MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY,
    MEMBER_ACCOUNT_ACTIVITY_INIT_CALL,
    MEMBER_AFFORDABILITY,
    MOCKS,
    MODAL_MOCKS,
    MULTIHOUSEHOLD_DETAILS,
    NAV_BAR,
    NEW_INBOX_HOME,
    NOTIFICATIONS,
    OLD_START_SSAP_BY_CASE_NUMBER,
    OVERRIDE_DOCUMENTS,
    PAY_FOR_HEALTH,
    CHANGE_TERMINATION_DATE,
    PARTNER_BROKER,
    PARTNER_LIST,
    PING,
    PLAN_SUMMARY,
    PLAN_SHOPPING,
    POST_ATTACHMENTS_URL,
    POST_TICKET,
    PRE_ELIGIBILITY,
    PRE_ELIGIBILITY_BROWSE_PLANS,
    PRE_ELIGIBILITY_BROWSE_PLANS_REDIRECT,
    PRE_ELIGIBILITY_CALCULATE_SAVINGS,
    PRE_ELIGIBILITY_DISCLAIMER,
    PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW,
    PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME,
    PRE_ELIGIBILITY_DISCLAIMER_JSP,
    PRE_ELIGIBILITY_RESULTS,
    PRE_ELIGIBILITY_RESULTS_APTC_IMAGE,
    PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE,
    PRE_ELIGIBILITY_RESULTS_CSR_IMAGE,
    PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE,
    PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE,
    PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE,
    PRE_ELIGIBILITY_RESULTS_NAVIGATE_NEXT,
    PRE_ELIGIBILITY_RESULTS_NA_IMAGE,
    PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE,
    PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE,
    PRE_ELIGIBILITY_SCREENING,
    PRE_OEP_LANDING,
    QEP,
    REASSIGN_BOB_TO_CEC,
    REMOVE_UPLOADED_DOCUMENT,
    REPORT_A_CHANGE,
    REQUEST_FULL_DETERMINATION,
    RESET_PASSWORD,
    RESET_PASSWORD_ALTERNATE_EMAIL,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN,
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN,
    REVIEW_SUMMARY_PDF_DOWNLOAD,
    RIDP_CURRENT_USER_INFO_ENDPOINT,
    RIDP_VIEWREF_ENDPOINT,
    RIDP_VALIDATE_PRIMARY_ENDPOINT,
    RIDP_VALIDATE_SECONDARY_ENDPOINT,
    RIDP_MANUAL_VERIFICATION_ENDPOINT,
    RIDP_VALIDATE_FARS_ENDPOINT,
    RIDP_CLEAR_DHS_ENDPOINT,
    SAVE_COMMENT,
    SAVE_CUSTOM_GROUPING,
    SAVE_DATA_ENDPOINT,
    SAVE_SEEKS_QHP_CHANGES,
    SAVE_TOBACCO,
    SEARCH_APPLICANT,
    SEARCH_CEC,
    SECURE_INBOX_SEND,
    SET_ACTIVE_HOUSEHOLD,
    SET_FULL_DETERMINATION,
    SCREENPOP_ASSISTER_DATA,
    SCREENPOP_BROKER_DATA,
    SSAP_PRE_ELIGIBILITY,
    SSIO_EXECUTE_STEP,
    SSIO_RESTART_STEP,
    SSIO_TEST_PLAN_DETAILS,
    SSIO_TEST_PLAN_RESULTS,
    START_SHOPPING,
    START_SSAP_BY_CASE_NUMBER,
    START_SSAP_BY_YEAR,
    SUBMIT_DOCUMENTS,
    TERMINATE_DENTAL_PLAN,
    TERMINATE_HEALTH_PLAN,
    TERMINATE_PLAN,
    TICKETS,
    TICKET_DETAIL,
    TICKET_MGMT_CANCEL_TICKET,
    TICKET_MGMT_CATEGORIES,
    TICKET_MGMT_COMPLETE_TASK,
    TICKET_MGMT_CREATE_PAGE,
    TICKET_MGMT_DEFAULT_QUEUE,
    TICKET_MGMT_EXCHANGE_ASSIGNEES,
    TICKET_MGMT_GET_ACTIVE_TASKS,
    TICKET_MGMT_GET_ALL_USERS_FOR_QUEUE,
    TICKET_MGMT_GET_CONSUMER_DATA,
    TICKET_MGMT_GET_FILE_UPLOAD_FLAG,
    TICKET_MGMT_GET_RECLASSIFIED_PROPERTIES,
    TICKET_MGMT_GET_TAGS,
    TICKET_MGMT_GET_TICKET_TYPES,
    TICKET_MGMT_LIST,
    TICKET_MGMT_MANAGE_QUEUE,
    TICKET_MGMT_PERMISSIONS,
    TICKET_MGMT_REASSIGN_TICKET,
    TICKET_MGMT_REOPEN_TICKET,
    TICKET_MGMT_SAVE_COMMENT,
    TICKET_MGMT_SAVE_NEW_TICKET_TYPE,
    TICKET_MGMT_SUBMIT_RECLASSIFY,
    TICKET_MGMT_TICKET_COMMENTS,
    TICKET_MGMT_TICKET_DETAIL,
    TICKET_MGMT_TICKET_DETAIL_BACKDOOR,
    TICKET_MGMT_TICKET_DOCUMENTS,
    TICKET_MGMT_TICKET_HISTORY,
    TICKET_MGMT_TICKET_SEND_MESSAGE,
    TICKET_MGMT_TICKET_TASKLIST,
    TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES,
    TICKET_MGMT_UPDATE_CATEGORY,
    TICKET_MGMT_UPDATE_TAG,
    TICKET_MGMT_UPLOAD_ATTACHMENTS,
    TICKET_MGMT_USER_TASKLIST,
    TICKET_MGMT_WORKFLOW_BY_CATEGORY,
    TICKET_MGMT_WORKFLOW_TYPES,
    TICKET_MGMT_WORKGROUPS,
    TICKET_MGMT_WORKGROUPS_TAGS,
    TICKET_MGMT_WORKGROUPS_SEARCH_ALL,
    TICKET_MGMT_WORKGROUPS_TAGS_BY_ID,
    TICKET_MGMT_WORKGROUPS_NAME_VALIDATION,
    TICKET_MGMT_UPDATE_WORKGROUP,
    TICKET_MGMT_TAGS_AUTOCOMPLETE_SEARCH,
    TICKET_MGMT_WORKGROUP_TAGS_SAVE,
    TICKET_TYPES,
    TOBACCO_EXEMPT,
    TOBACCO_EXEMPT_GET_APPLICANTS,
    TOBACCO_EXEMPT_SAVE_ADDINFO,
    TRIBES_ENDPOINT,
    UNLOCK_USER,
    UNREAD_MESSAGE_COUNT,
    UPLOADED_DOCUMENT_URL,
    UPLOAD_VERIFICATION_DOCUMENT,
    VALIDATE_ADDRESS_ENDPOINT,
    VALIDATE_ZIP,
    VERIFICATION_PENDING,
    VERIFICATION_RESULT_DASHBOARD,
    VERIFY_ACCESS_CODE,
    VIEW_ATTACHMENT_URL,
    VIEW_MEMBER,
    VIEW_MEMBER_ACCOUNT,
    DMI_VIEW_UPLOADED_DOCUMENT_ENDPOINT,
    DMI_VIEW_TICKET_ENDPOINT,
    WORKGROUP_BY_DUEDATE,
    WORKGROUP_BY_STATUS,
    WORKGROUP_BY_USER,
    WORKGROUP_DUEDATE_REPORT_BY_USER,
    WRONG_ENDPOINT,
    ZIPCODE_COUNTIES,
    MEMBER_APP_LIST_CONTROLLER,
    MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS,
    MEMBER_APP_LIST_GET_APPS,
    MEMBER_APP_LIST_OVERRIDE_COMMENT,
    MEMBER_APP_LIST_INIT_VERIFICATIONS,
    MEMBER_APP_LIST_RERUN_ELIGIBILITY,
    MEMBER_APP_LIST_TERMINATE_PLAN,
    MEMBER_APP_LIST_UPDATE_CARRIER,
    MEMBER_APP_LIST_REVERSE_DENIAL,
    MEMBER_APP_LIST_SAVE_SEP_DETAILS,
    MEMBER_APP_LIST_SEND_OBAT,
    MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS,
    MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP,
    MEMBER_APP_LIST_CHECK_ACTIVE,
    MEMBER_APP_LIST_PROGRAM_ELIGIBILITY,
    MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY,
    MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT,
    MEMBER_APP_LIST_SEP_EVENT_DETAILS,
    MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER,
    MEMBER_APP_LIST_GET_SEP_DETAILS,
    MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS,
    MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK,
    MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS,
    MEMBER_APP_LIST_GET_SEP_PERIOD_DATES,
    MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE,
    MEMBER_APP_LIST_GET_QHP_APPLICANTS,
    MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW,
    MEMBER_APP_LIST_NEW_SSAP_START,
    MEMBER_APP_LIST_APPLICATIONS,
    ADMIN_PROVISION_PRIVILEGES,
    ADMIN_PROVISION_UPDATE_PRIVILEGES,

    ADMIN_GET_DRUG_LIST,
};
